import * as _ from 'lodash';
import { FETCH_ALL_DESTINATION_SUCCEEDED } from './../../../destination/destination.action';
import {
  FETCH_PRODUCTS_LOCATION_SUCCEEDED,
  SEARCH_PRODUCT_LOCATION_SUCCEEDED,
  FETCH_TRACKED_PRODUCTS_SUCCEEDED,
  COMPLETE_SCAN_SUCCEEDED,
  FETCH_EXTRA_PRODUCT_SUCCEEDED,
  UPDATE_SORT_BY_STATUS_DIRECTION,
  MAP_CURRENT_LOCATION_TO_PRODUCT,
  FETCH_ALL_LOCATIONS,
  // FETCH_CURRENT_LOCATION,
  SCAN_RACK_MOVING_PRODUCT_LOCATION,
  MARKED_AS_FOUND_SUCCEEDED,
  FETCH_LOCATION_OF_TRACKED_PRODUCT_SUCCEEDED,
  SCAN_RACK_UPDATE_PRODUCT_DESTINATION,
  SCAN_RACK_UPDATE_PRODUCT_LOCATION,
  REMOVE_SCANNED_ITEM_SUCCEEDED
} from './edit.actions';
import { TRACKED_PRODUCT_STATUS_FOUND, TRACKED_PRODUCT_STATUS_TEXT_FOUND, SCAN_RACK_COMP, MOVE_TO_LOST_AND_FOUND_DESTINATION_TYPE } from './edit.const';
import ProductTrack from '../../../../models/ProductTrack';
import { SCAN_LOCATION_SUCCEEDED } from '../list/list.actions';
import { SAVE_PRODUCT_LOCATION, SAVE_PRODUCT_LOCATION_SUCCEEDED } from '../../batch/batch.actions';

const TrackedProduct = (state: any = {}, action) => {
  switch (action.type) {
    case SCAN_RACK_UPDATE_PRODUCT_DESTINATION:
      if (action.item.getId() === state.getId()) {
        state = _.assign(_.clone(state), {
          destination_id: action.data.getId()
        });
      }
      return state;
    case SCAN_RACK_UPDATE_PRODUCT_LOCATION:
      if (action.item.getId() === state.getId()) {
        state = _.assign(_.clone(state), { location_id: action.data.getId() });
      }
      return state;
    case FETCH_LOCATION_OF_TRACKED_PRODUCT_SUCCEEDED:
      let product_location = _.find(action.data, i => i.getProductId() === state.getId());
      if (!_.isUndefined(product_location)) {
        state = _.assign(_.clone(state), {
          location: product_location.getLocation(),
          destination: product_location.getDestination(),
          current_location: _.clone(product_location.getLocation()),
          current_destination: product_location.getDestination()
        });
      }
      return state;
    case FETCH_ALL_DESTINATION_SUCCEEDED:
      if (!_.isUndefined(state.destination)) {
        let destination = _.find(action.data, i => i.getId() === state.destination.getId());
        state = _.assign(_.clone(state), {
          destination: destination,
          destination_id: destination.getId()
        });
        if (!_.isUndefined(state.location)) {
          let location = _.find(destination.locations, item => item.getId() === state.location.getId());
          if (!_.isUndefined(location)) {
            state = _.assign(state, {
              location: location,
              location_id: location.getId()
            });
          }
        }
      }
      return state;
    case SAVE_PRODUCT_LOCATION:
      if (action.data.product_sku === state.getSku()) {
        state = _.assign(_.clone(state), {
          destination: action.destination,
          destination_id: action.destination.id
        });
      }
      return state;
    default:
      return state;
  }
};

const ProductLocation = (state: any = {}, action) => {
  switch (action.type) {
    case FETCH_TRACKED_PRODUCTS_SUCCEEDED:
      let product = _.find(action.data, i => i.getId() === state.getProductId());
      if (!_.isUndefined(product)) {
        state = _.assign(_.clone(state), {
          tracked: product.product_track,
          status: product.product_track.getStatus()
        });
      }
      return state;
    case SAVE_PRODUCT_LOCATION_SUCCEEDED:
      if (state.getProductId() === action.data.getProductId() && state.getLocationId() !== action.data.getLocationId()) {
        state = _.assign(_.clone(state), {
          moved: true
        });
      }
      return state;
    default:
      return state;
  }
};

export const edit = (state: any = { trackDetail: {}, sortByStatusDirection: undefined, completedTracks: [], completed: false }, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS_LOCATION_SUCCEEDED:
      return _.assign({}, state, { fetched: true, items: action.data, location_id: Number(action.location_id), track_id: Number(action.track_id) });

    case SEARCH_PRODUCT_LOCATION_SUCCEEDED:
      return _.assign({}, state, {
        items: (state as any).items.map(item => (item.getId() === action.data.getId() ? _.assign(_.clone(item), { status: TRACKED_PRODUCT_STATUS_FOUND }) : item))
      });

    case FETCH_TRACKED_PRODUCTS_SUCCEEDED:
      return _.assign({}, state, {
        tracked_products: action.data,
        completed: false,
        completedTracks: action.data,
        items: _.map(state.items, item => ProductLocation(item, action))
      });

    case COMPLETE_SCAN_SUCCEEDED:
      return _.assign({}, state, { completed: true, completedTracks: action.data });

    case MAP_CURRENT_LOCATION_TO_PRODUCT:
      return _.assign({}, state, {
        completedTracks: _.map(action.completedTracks, item => {
          let i = _.find(action.inventories, {
            product_sku: item.getSku()
          });
          return _.assign(_.clone(item), {
            location: i.location
          });
        })
      });

    case SCAN_LOCATION_SUCCEEDED:
      return _.assign({}, state, { latestScan: action.latestScan, trackDetail: action.data });

    case UPDATE_SORT_BY_STATUS_DIRECTION:
      return _.assign({}, state, { sortByStatusDirection: action.data });

    case FETCH_ALL_LOCATIONS:
      return _.assign({}, state, {
        locations: action.data,
        currentLocation: _.find(action.data, item => item.getId() === state.location_id)
      });

    case SCAN_RACK_MOVING_PRODUCT_LOCATION:
      let resetCompletedTracks = _.map((state as any).completedTracks, item => {
        if (item.id === action.data.product_id) {
          return _.assign({}, item, {
            product_track: _.assign(_.clone(item.product_track), {
              status: TRACKED_PRODUCT_STATUS_FOUND,
              status_text: TRACKED_PRODUCT_STATUS_TEXT_FOUND
            })
          });
        } else {
          return item;
        }
      });

      let resetItems = _.map((state as any).items, item => {
        if (item.product_id === action.data.product_id) {
          return _.assign(_.clone(item), {
            status: TRACKED_PRODUCT_STATUS_FOUND,
            tracked: _.assign(_.clone(item.tracked), {
              status: TRACKED_PRODUCT_STATUS_FOUND,
              status_text: TRACKED_PRODUCT_STATUS_TEXT_FOUND
            })
          });
        } else {
          return item;
        }
      });
      return _.assign({}, state, {
        completedTracks: resetCompletedTracks,
        items: resetItems
      });

    case MARKED_AS_FOUND_SUCCEEDED:
      return _.assign({}, state, {
        completedTracks: _.assign(
          _.clone((state as any).completedTracks),
          _.map((state as any).completedTracks, item => {
            if (item.getId() === action.data.getProductId()) {
              return _.assign(_.clone(item), {
                product_track: _.assign(_.clone(item.product_track), {
                  status: TRACKED_PRODUCT_STATUS_FOUND,
                  status_text: TRACKED_PRODUCT_STATUS_TEXT_FOUND
                }),
                status: TRACKED_PRODUCT_STATUS_FOUND
              });
            } else {
              return item;
            }
          })
        ),
        items: _.assign(
          _.clone(state as any).items,
          _.map((state as any).items, item => {
            if (item.getProductId() === action.data.getProductId()) {
              return _.assign(_.clone(item), {
                product_track: _.assign(_.clone(item), {
                  status: TRACKED_PRODUCT_STATUS_FOUND,
                  status_text: TRACKED_PRODUCT_STATUS_TEXT_FOUND
                }),
                status: TRACKED_PRODUCT_STATUS_FOUND
              });
            } else {
              return item;
            }
          })
        )
      });

    case FETCH_LOCATION_OF_TRACKED_PRODUCT_SUCCEEDED:
      return _.assign({}, state, {
        tracked_products: _.map(state.tracked_products, item => TrackedProduct(item, action))
      });
    case REMOVE_SCANNED_ITEM_SUCCEEDED:
      return _.assign({}, state, {
        tracked_products: _.filter(state.tracked_products, item => item.getId() !== action.product.getId()),
        items: _.map(state.items, item => {
          if (item.getProductId() === action.product.getId()) {
            delete item.tracked;
            delete item.status;
          }
          return item;
        })
      });
    case SCAN_RACK_UPDATE_PRODUCT_DESTINATION:
    case SCAN_RACK_UPDATE_PRODUCT_LOCATION:
      return _.assign({}, state, {
        tracked_products: _.map(state.tracked_products, item => TrackedProduct(item, action))
      });
    case SAVE_PRODUCT_LOCATION:
      if (action.btn === MOVE_TO_LOST_AND_FOUND_DESTINATION_TYPE && action.com === SCAN_RACK_COMP) {
        state = _.assign({}, state, {
          tracked_products: _.map(state.tracked_products, item => TrackedProduct(item, action))
        });
      }
      return state;
    case SAVE_PRODUCT_LOCATION_SUCCEEDED:
      if (action.com === SCAN_RACK_COMP) {
        state = _.assign({}, state, {
          items: _.map(state.items, item => ProductLocation(item, action))
        });
      }
      return state;
    case FETCH_ALL_DESTINATION_SUCCEEDED:
      if (action.com === SCAN_RACK_COMP) {
        state = _.assign({}, state, {
          tracked_products: _.map(state.tracked_products, item => TrackedProduct(item, action))
        });
      }
      return state;
    default:
      return state;
  }
};
